import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserList } from "./list";

export default () => {
  return (
    <Routes>
      <Route index element={<UserList />} />
    </Routes>
  );
};
